function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M158.18 22a20.6 20.6 0 00-17.9-18.1 468.12 468.12 0 00-120.6 0A20.5 20.5 0 001.88 22a299.31 299.31 0 000 66.9 20.5 20.5 0 0017.8 18.1 468.8 468.8 0 0060.4 3.9 467.26 467.26 0 0060.3-3.9 20.5 20.5 0 0017.8-18.1 288.13 288.13 0 001.9-33.5 286.42 286.42 0 00-1.9-33.4zm-54.9 36.6l-32.8 23.1a2.89 2.89 0 01-4-.7 2.62 2.62 0 01-.5-1.7V31.4a2.88 2.88 0 012.8-2.9 3.37 3.37 0 011.7.5l32.8 23.1a3.89 3.89 0 011 5.42l-.06.08a3 3 0 01-.94 1z"
});

var SvgSocialYoutube = function SvgSocialYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "6422efd7-88eb-4595-bdca-bb8e78e5619a",
    viewBox: "0 0 160.08 110.9",
    "aria-hidden": true
  }, props), _ref);
};

export default SvgSocialYoutube;